export default {
    inject: ["CookieStore"],
    computed: {
        isShowBannerCookie: function () {
            return this.CookieStore.state.active;
        },
        cookieClass: function () {
            if (this.isShowBannerCookie) {
                return 'accept-cookie'
            }
            return '';
        }
    },
    methods: {
        acceptCookie: function () {
            this.CookieStore.methods.acceptCookie();
        }
    }
}
